import { useContext } from "react";

import type { DashboardConfig } from "@lib/dashboardConfig";

import { BrazeDashboardConfigContext } from "./BrazeDashboardConfigContext";

export const useBrazeDashboardConfig = <SubField extends keyof DashboardConfig>(
  field: SubField
): DashboardConfig[SubField] => {
  const [config] = useContext(BrazeDashboardConfigContext);

  return config[field];
};
